import { ChevronLeft, Save } from "lucide-react";
import { FramedImage } from "../site/FramedImage";

// Événement global : une fiche demande l'enregistrement du brouillon (écouté par AdminDashboard).
export const FICHE_SAVE_EVENT = "ks:fiche-save";
const requestFicheSave = () => window.dispatchEvent(new CustomEvent(FICHE_SAVE_EVENT));

// Pattern partagé « Cartes + Fiche dédiée » : chaque élément d'une liste admin devient une
// carte compacte dans une grille ; cliquer ouvre une fiche plein écran dédiée à cet élément
// (titre toujours visible en haut, modification 100 % isolée des autres éléments).

export const FicheOverlay = ({ title, subtitle, onClose, actions, children, testid = "fiche-overlay" }) => (
  <div className="fixed inset-0 z-[9995] bg-[#050505] overflow-y-auto" data-testid={testid}>
    <div className="sticky top-0 z-10 bg-black/85 backdrop-blur-xl border-b border-electric/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-3 sm:gap-4">
        <button type="button" onClick={onClose} data-testid={`${testid}-back`}
          className="inline-flex items-center gap-1.5 text-xs text-secondary2 hover:text-electric shrink-0 rounded-full border border-white/10 px-3 py-1.5 transition-colors">
          <ChevronLeft size={14} /> Retour
        </button>
        <div className="min-w-0 flex-1">
          <div className="font-serif text-lg sm:text-xl text-white truncate" data-testid={`${testid}-title`}>{title || "Sans titre"}</div>
          {subtitle && <div className="text-[10px] uppercase tracking-[0.2em] text-secondary2 truncate">{subtitle}</div>}
        </div>
        {/* Par défaut : bouton Enregistrer (le bandeau principal est couvert par la fiche).
            `actions` fourni = actions personnalisées (ex : annonces, sauvegarde API directe). */}
        <div className="flex items-center gap-2 shrink-0">
          {actions === undefined ? (
            <button type="button" onClick={requestFicheSave} data-testid={`${testid}-save`}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-electric text-black text-[11px] tracking-[0.1em] uppercase font-semibold hover:bg-white transition-colors">
              <Save size={13} /> Enregistrer
            </button>
          ) : actions}
        </div>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 pb-24 space-y-4">{children}</div>
  </div>
);

export const CardGrid = ({ children, testid }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3" data-testid={testid}>{children}</div>
);

export const ItemCard = ({ image, frame, title, subtitle, badges = [], actions, onOpen, testid, dimmed }) => (
  <div data-testid={testid}
    className={`group rounded-xl border bg-[#0a0a0a] overflow-hidden transition-colors ${dimmed ? "border-white/5 opacity-60" : "border-white/10 hover:border-electric/50"}`}>
    <button type="button" onClick={onOpen} data-testid={testid ? `${testid}-open` : undefined} className="block w-full text-left">
      <div className="relative h-28 bg-[#0e0e0e] overflow-hidden">
        {image
          ? <FramedImage src={image} frame={frame} alt="" />
          : <div className="w-full h-full flex items-center justify-center text-[10px] text-white/25 uppercase tracking-[0.2em]">Aucun visuel</div>}
        {badges.length > 0 && (
          <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
            {badges.map((b, i) => (
              <span key={i} className={`text-[9px] uppercase tracking-[0.12em] rounded-full px-2 py-0.5 border backdrop-blur ${b.tone || "text-white/80 border-white/20 bg-black/60"}`}>{b.label}</span>
            ))}
          </div>
        )}
      </div>
      <div className="p-3.5">
        <div className="text-sm text-white font-medium line-clamp-1">{title || "Sans titre"}</div>
        {subtitle && <div className="text-[11px] text-secondary2 line-clamp-1 mt-0.5">{subtitle}</div>}
        <div className="text-[10px] uppercase tracking-[0.18em] text-electric mt-2 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">Modifier →</div>
      </div>
    </button>
    {actions && <div className="flex items-center justify-end gap-1 px-3 pb-3">{actions}</div>}
  </div>
);
